<script setup lang="ts">
import { quantityBus } from '@/event/product/quantityBus'
import { ref } from 'vue'
import { Plus, Minus } from 'lucide-vue-next'

const counterProduct = ref(quantityBus.value ? quantityBus.value : 0)

function increment() {
    counterProduct.value++
    quantityBus.value = counterProduct.value
}

function decrement() {
    if (counterProduct.value > 1) {
        counterProduct.value--
        quantityBus.value = counterProduct.value
    }
}
</script>

<template>
    <section class="section-button-select-product-happy">
        <div class="min-w-6 min-h-6">
            <button
                class="button-minus-product-happy"
                @click.stop="decrement()"
                v-if="counterProduct > 1"
            >
                <Minus :size="18" :stroke-width="2" class="svg-minus-happy" />
            </button>
        </div>
        <p class="text-counter-option-value-happy">{{ counterProduct }}</p>

        <button class="button-plus-product-happy" @click.stop="increment()">
            <Plus :size="18" :stroke-width="2" class="svg-plus-happy" />
        </button>
    </section>
</template>

<style scoped>
.section-button-select-product-happy {
    @apply flex items-center justify-between gap-2 min-w-28;
}

.button-minus-product-happy {
    /* refactored */
    @apply flex items-center border-2 shadow-sm rounded-md p-1 w-full h-full;
    @apply bg-t-accent border-t-accent text-t-on-accent;
    @apply happy-ifo-dark:border-t-accent/30 happy-ifo-dark:shadow-none happy-ifo-dark:bg-t-accent/10 happy-ifo-dark:rounded-full;
}

.svg-minus-happy {
    /* refactored */
    @apply w-[18px] h-[18px] text-t-on-accent;
    @apply happy-ifo-dark:text-t-text;
}

.text-counter-option-value-happy {
    /* refactored */
    @apply text-lg text-center w-6 font-semibold text-t-text;
}

.button-plus-product-happy {
    /* refactored */
    @apply flex items-center p-1 shadow-sm rounded-md border-2;
    @apply bg-t-accent border-t-accent text-t-on-accent;
    @apply happy-ifo-dark:bg-t-accent/10 happy-ifo-dark:border-t-accent/30 happy-ifo-dark:shadow-none happy-ifo-dark:rounded-full;
}
.svg-plus-happy {
    /* refactored: Lucide uses currentColor */
    @apply w-[18px] h-[18px] text-t-on-accent;
    @apply happy-ifo-dark:text-t-accent;
}

.button-plus-product-happy:active,
.button-plus-product-happy:focus {
    /* refactored */
    @apply bg-t-accent-hover border-t-accent-hover;
    @apply happy-ifo-dark:bg-t-accent-hover happy-ifo-dark:border-t-accent;
}

.button-plus-product-happy:active .svg-plus-happy,
.button-plus-product-happy:focus .svg-plus-happy {
    /* refactored: Lucide uses currentColor */
    @apply text-t-on-accent;
    @apply happy-ifo-dark:text-t-text;
}

.button-minus-product-happy:active,
.button-minus-product-happy:focus {
    /* refactored */
    @apply bg-t-accent-hover border-t-accent-hover;
    @apply happy-ifo-dark:bg-t-accent-hover happy-ifo-dark:border-t-accent;
}

.button-minus-product-happy:active .svg-minus-happy,
.button-minus-product-happy:focus .svg-minus-happy {
    /* refactored */
    @apply text-t-on-accent;
    @apply happy-ifo-dark:text-t-text;
}

@media (hover: hover) {
    .button-plus-product-happy:hover {
        /* refactored */
        @apply bg-t-accent-hover border-t-accent-hover;
        @apply happy-ifo-dark:bg-t-accent-hover happy-ifo-dark:border-t-accent;
    }

    .button-plus-product-happy:hover .svg-plus-happy {
        /* refactored: Lucide uses currentColor */
        @apply text-t-on-accent;
        @apply happy-ifo-dark:text-t-text;
    }

    .button-minus-product-happy:hover {
        /* refactored */
        @apply bg-t-accent-hover border-t-accent-hover;
        @apply happy-ifo-dark:bg-t-accent-hover happy-ifo-dark:border-t-accent;
    }

    .button-minus-product-happy:hover .svg-minus-happy {
        /* refactored */
        @apply text-t-on-accent;
        @apply happy-ifo-dark:text-t-text;
    }
}
</style>
